import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { ICompany } from 'models/company';
import { IIndustry } from 'models/industry';
import { useTranslation } from 'react-i18next';


interface Props {
  open: boolean;
  loading: boolean;
  company: ICompany;
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const EditSMS: React.FC<Props> = ({ open, loading, company,  onClose, onSubmit, onChanges }) => {
  const {t} = useTranslation()

  let basicFields: IFormField[] = [
    {
      name: 'twilioAccountSid',
      label: t('T_sms_1'),
      type: InputTypes.TEXT,
      internalLabel: true,
      defaultValue:company?.twilioAccountSid
    },
    {
      name: 'twilioAuthToken',
      label: t('T_sms_2'),
      type: InputTypes.TEXT,
      internalLabel: true,
      defaultValue:company?.twilioAuthToken
    },
    {
      name: 'twilioFromSenderName',
      label: t('T_sms_3'),
      type: InputTypes.TEXT,
      internalLabel: true,
      defaultValue:company?.twilioFromSenderName
    },
    {
      name: 'twilioWhatsappFromMobile',
      label: t('T_sms_4'),
      type: InputTypes.TEXT,
      internalLabel: true,
      defaultValue:company?.twilioWhatsappFromMobile
    },
 

  ];



  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_edit_sms')}
      maxWidth="lg"
      children={<Grid container p={2}>
        <Form fields={basicFields} onChange={onChanges} />
      </Grid>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
             {t('T_save')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default EditSMS;